module.exports = require("@tiptap/extension-font-family");